import React from 'react'
import PropTypes from 'prop-types'
import {
    VStack,
    Text,
    Image,
    Flex,
    Box,
    useMultiStyleConfig,
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {Link as ReactRouterLink} from 'react-router-dom'
import {Link as ChakraLink} from '@chakra-ui/react'
import {useGetCategoriesData} from '../../../custom-api/hooks/use-get-categories-data'
import {getGlobalLink} from '../../../utils/contentstack-utils'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'

export default function QuickLinks({quickLinksData, title}) {
    const styles = useMultiStyleConfig('Faq', {})
    const {quickLinkStyles} = styles || null
    const categoryData = useGetCategoriesData()
    const {buildUrl} = useMultiSite()

    return (
        <VStack {...quickLinkStyles?.outerContainer}>
            <Text {...quickLinkStyles?.titleText}>{title}</Text>
            <Flex {...quickLinkStyles?.flexContainer}>
                {quickLinksData.map((link, index) => {
                    const {url, label, isAbsolute} = getGlobalLink(link?.button, categoryData)
                    const buttonProps = isAbsolute
                        ? {
                              as: 'a',
                              href: url,
                              target: '_blank',
                              rel: 'noopener noreferrer',
                          }
                        : {
                              as: ReactRouterLink,
                              to: buildUrl(url),
                          }
                    return (
                        <Box key={index}>
                            <ChakraLink {...buttonProps} {...quickLinkStyles?.flexItem}>
                                <Image
                                    src={link?.icon?.url}
                                    {...quickLinkStyles?.iconWraper}
                                    data-testid="icon"
                                />
                                <Text {...quickLinkStyles?.gridItemText}>{label}</Text>
                            </ChakraLink>
                        </Box>
                    )
                })}
            </Flex>
        </VStack>
    )
}

QuickLinks.propTypes = {
    title: PropTypes.string,
    quickLinksData: PropTypes.array,
}
